module.exports = __webpack_public_path__ + "static/media/MP.7a0f2947.svg";